function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.682 28.373l-12.555-7.235v23.404l12.555 3.78zM44.697 21.139L32.062 28.42v19.91l12.635-3.791zM53.069 19.063c-.82 0-1.485.664-1.485 1.484v1.597h2.97v-1.597a1.486 1.486 0 00-1.485-1.484M53.815 23.305H51.58v20.822l1.488 5.182 1.484-5.182V23.305h-.37z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.049 45.178l-13.95 4.498H30.682l-13.887-3.873v-24.72l-1.347 1.06v24.603l15.17 4.192H32.164l13.996-4.436 1.235-.363V22.143l-1.345-1.06z"
}));

var SvgOds04 = function SvgOds04(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOds04, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ods04.46dfd880.svg";
export { ForwardRef as ReactComponent };